document.addEventListener('DOMContentLoaded', function () {
  var countdowns = document.querySelectorAll('.countdown-hero__timer');

  countdowns.forEach(function (el) {
    var targetValue = el.getAttribute('data-target');
    var expiredText = el.getAttribute('data-expired-text') || 'Now live';

    if (!targetValue) return;

    var daysEl = el.querySelector('[data-days]');
    var hoursEl = el.querySelector('[data-hours]');
    var minutesEl = el.querySelector('[data-minutes]');
    var secondsEl = el.querySelector('[data-seconds]');
    var expiredMessage = el.parentElement.querySelector('[data-expired-message]');

    function pad(num) {
      return String(num).padStart(2, '0');
    }

    function updateCountdown() {
      var target = new Date(targetValue).getTime();
      var now = new Date().getTime();
      var diff = target - now;

      if (isNaN(target) || diff <= 0) {
        if (daysEl) daysEl.textContent = '00';
        if (hoursEl) hoursEl.textContent = '00';
        if (minutesEl) minutesEl.textContent = '00';
        if (secondsEl) secondsEl.textContent = '00';

        el.setAttribute('hidden', 'hidden');

        if (expiredMessage) {
          expiredMessage.hidden = false;
          expiredMessage.textContent = expiredText;
        }
        return;
      }

      var days = Math.floor(diff / (1000 * 60 * 60 * 24));
      var hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
      var minutes = Math.floor((diff / (1000 * 60)) % 60);
      var seconds = Math.floor((diff / 1000) % 60);

      if (daysEl) daysEl.textContent = pad(days);
      if (hoursEl) hoursEl.textContent = pad(hours);
      if (minutesEl) minutesEl.textContent = pad(minutes);
      if (secondsEl) secondsEl.textContent = pad(seconds);
    }

    updateCountdown();
    setInterval(updateCountdown, 1000);
  });
});

document.addEventListener('DOMContentLoaded', function () {
  var klaviyoButtons = document.querySelectorAll('.js-open-klaviyo-form');

  klaviyoButtons.forEach(function (button) {
    button.addEventListener('click', function (event) {
      event.preventDefault();
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', 'U8vXtp']);
    });
  });
});